/* eslint no-undef: 0 */

// Load Styles
import '../scss/custom.scss';

import './navigation';

// Greensock only on the home page?
import './gsap';
import './scrollTrigger';
import './CSSRulePlugin';

// Custom Scripts
import './scripts';